export const COUNTING_METHOD_BLOCK_CONFIG = {
	nonAutomatic: {
		iconWidth: 16,
		iconHeight: 16,
	},
}

export const BLOCKS_GAP = 26;

export const COUNT_SETTINGS_SAVING_TIMEOUT = 1000;